import { numberFormatLocale } from 'src/locales';

// ----------------------------------------------------------------------

export function fValidateNumber(inputValue) {
  if (typeof inputValue === 'string') inputValue = inputValue.replace(/,/g, '') * 1;

  if (!inputValue || Number.isNaN(inputValue)) return 0;

  return Number(inputValue);
}

export function fNumber(inputValue, options) {
  const locale = numberFormatLocale();
  const number = fValidateNumber(inputValue);

  const fm = new Intl.NumberFormat(locale.code, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(number);

  return fm;
}

export function fCurrency(inputValue, defaultLocale, options) {
  const locale = defaultLocale || numberFormatLocale();
  const number = fValidateNumber(inputValue);

  const fm = new Intl.NumberFormat(locale.code, {
    style: 'currency',
    currency: locale.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(number);

  return fm;
}

export function fCurrencySymbol(defaultLocale) {
  const locale = defaultLocale || numberFormatLocale();

  const fm = new Intl.NumberFormat(locale.code, {
    style: 'currency',
    currency: locale.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).formatToParts(0);

  return fm.find(({ type }) => type === 'currency').value;
}

export function fPercent(inputValue, options) {
  const locale = numberFormatLocale();
  const number = fValidateNumber(inputValue);

  const fm = new Intl.NumberFormat(locale.code, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    ...options,
  }).format(number / 100);

  return fm;
}

export function fShortenNumber(inputValue, options) {
  const locale = numberFormatLocale();
  const number = fValidateNumber(inputValue);

  const fm = new Intl.NumberFormat(locale.code, {
    notation: 'compact',
    maximumFractionDigits: 2,
    ...options,
  }).format(number);

  return fm.replace(/[A-Z]/g, (match) => match.toLowerCase());
}

export function fData(inputValue) {
  const number = fValidateNumber(inputValue);

  if (number === 0) return '0 bytes';

  const units = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];
  const decimal = 2;
  const baseValue = 1024;
  const index = Math.floor(Math.log(number) / Math.log(baseValue));
  const fm = `${parseFloat((number / baseValue ** index).toFixed(decimal))} ${units[index]}`;

  return fm;
}

export function getMaxPrice(data) {
  if (!data.length) return 0;

  return data?.reduce((a, b) => (a.priceSale > b.priceSale ? a : b))?.priceSale ?? 0;
}

export function calcPercent(prevTotal = 0, lastTotal = 0) {
  if (prevTotal === 0 && lastTotal === 0) return 0;

  if (prevTotal === 0) return 100;

  return fNumber(((lastTotal - prevTotal) / prevTotal) * 100);
}

export function getPercentFromArray(index = 0, array = []) {
  if (index < 0 || index > array.length - 1) return 0;

  const prevTotal = index === 0 ? 0 : array[index - 1];

  return calcPercent(prevTotal, array[index]);
}
